<div class="content-wsp-chat">
  <a class="wsp-chat-link" [href]="getWhatsAppLink()" target="_blank">
    <fa-icon [icon]="faWhatsapp"></fa-icon>
  </a>
</div>

<footer>
  <div class="footer-top">
    <div class="container">
      <div class="footer-content">
        <div class="social-icons">
          <img src="https://imagineapps.co/_assets/v11/8c8fe80147819ebbab415af8999241511f76c6c2.png" alt="plataforma footer" class="footer-logo" />
          <div class="social-row"> <!-- Nuevo contenedor para la segunda fila -->
            <div>
                  <p class="follow-text">{{ 'footer.follow_us' | optimizedI18n }}: </p>
            </div>
            <div>
              <a href="https://www.instagram.com/NombreEmpresa/" target="_blank" class="social-link">
                <fa-icon [icon]="faInstagram" class = "insta-icon"></fa-icon>
              </a>
            </div>

          </div>
          <!-- <a href="https://www.youtube.com/@plataformaequino?si=jWCVFKOQWt7-Fd-o" target="_blank" class="social-link">
            <fa-icon [icon]="faYoutube"></fa-icon>
          </a> -->
          <!-- <a href="https://www.tiktok.com/@plaixe.co?is_from_webapp=1&sender_device=pc" target="_blank" class="social-link">
            <fa-icon [icon]="faTiktok"></fa-icon>
          </a> -->
        </div>
        <!-- <div class="social-icons">
          <img src="/assets/img/footerLogo.svg" alt="plataforma footer" class="footer-logo center-logo" />
          <p class = "follow-text">Síguenos en: </p>
          <a href="https://www.instagram.com/plaixe.co/" target="_blank" class="social-link">
            <fa-icon [icon]="faInstagram"></fa-icon>
          </a>
      
        </div> -->

        <div class = "river-contact">
            <a>{{ 'footer.contact_us' | optimizedI18n }}: </a>
          <a>  +57 301 985 40 97  </a>
          <span class="separator"> | </span>
          <a>tu_correo@ejemplo.com</a>
        </div>
       
        <div class = "right-logo-container">
          <div>
            <img src="/assets/img/colombianFlag.svg" alt="plataforma footer" class="footer-logo right-logo" />
          </div>
          <div class = "right-logo-text-container">
            <p>{{ 'footer.text_colombian' | optimizedI18n }}</p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  <div class="plaixe-footer">
    <div class="footer-content">
      <div class="footer-links">
            <a href="/home/terms-and-conditions"
              class="footer-link">{{ 'footer.terms_conditions' | optimizedI18n }}</a>
            <span class="separator">|</span>
            <a href="/home/treatment-policy"
              class="footer-link">{{ 'footer.privacy_policy' | optimizedI18n }}</a>
            <span class="separator">|</span>
            <a href="#" class="footer-link">{{ 'footer.copyright' | optimizedI18n }} ©2025</a>
      </div>
    </div>
  </div>
</footer>